import { ArgumentError } from "../api/errors";
import { Action } from "./action";
import { MoveToAction } from "./utilityActions";
import { TestCase, World } from "./testCase";
import { SceneGroup, SceneGraphic, TextSceneNode, LineSceneNode, OffsetProxy, FillSceneGraphic } from "../api/scene";
import { AxisSceneGroup, CenterSceneGroup } from "../api/sceneGroup";
import { TweenLite } from "gsap";
class AddExpression {
    constructor(data, parser) {
        if (data.left == undefined || data.right == undefined) {
            throw new ArgumentError( /*"AddExpression requires left and right children."*/);
        }
        this._left = parser.parse(data.left);
        this._right = parser.parse(data.right);
    }
    toString() {
        return "add(" + this._left.toString() + ", " + this._right.toString() + ")";
    }
    //INumberExpression-->
    evaluate() {
        return this._left.evaluate() + this._right.evaluate();
    }
}
class DivideExpression {
    constructor(data, parser) {
        if (data.left == undefined || data.right == undefined) {
            throw new ArgumentError( /*"AddExpression requires left and right children."*/);
        }
        this._left = parser.parse(data.left);
        this._right = parser.parse(data.right);
    }
    toString() {
        return "divide(" + this._left.toString() + ", " + this._right.toString() + ")";
    }
    //INumberExpression-->
    evaluate() {
        return this._left.evaluate() / this._right.evaluate();
    }
}
class FunctionCallExpression {
    constructor(data, parser) {
        this._functionName = data.name;
        this._parser = parser;
    }
    toString() {
        if (this._functionName != null) {
            return this._functionName + "()";
        }
        return "";
    }
    //INumberExpression-->
    evaluate() {
        return this._parser.getFunctionCallValue(this._functionName);
    }
}
class ModuloExpression {
    constructor(data, parser) {
        this._left = parser.parse(data.left);
        this._right = parser.parse(data.right);
    }
    toString() {
        return "modulo(" + this._left.toString() + ", " + this._right.toString() + ")";
    }
    //INumberExpression-->
    evaluate() {
        return this._left.evaluate() % this._right.evaluate();
    }
}
class MultiplyExpression {
    constructor(data, parser) {
        if (data.left == undefined || data.right == undefined) {
            throw new ArgumentError( /*"AddExpression requires left and right children."*/);
        }
        this._left = parser.parse(data.left);
        this._right = parser.parse(data.right);
    }
    toString() {
        return "multiply(" + this._left.toString() + ", " + this._right.toString() + ")";
    }
    //INumberExpression-->
    evaluate() {
        return this._left.evaluate() * this._right.evaluate();
    }
}
class NegateExpression {
    constructor(data, parser) {
        if (data.right == undefined) {
            throw new ArgumentError( /*"AddExpression requires left and right children."*/);
        }
        this._right = parser.parse(data.right);
    }
    toString() {
        return "negate(" + this._right.toString() + ")";
    }
    //INumberExpression-->
    evaluate() {
        return -this._right.evaluate();
    }
}
class NumberConstantExpression {
    constructor(data) {
        this._value = data.value;
    }
    toString() {
        return this._value.toString();
    }
    //INumberExpression-->
    evaluate() {
        return this._value;
    }
}
class SubtractExpression {
    constructor(data, parser) {
        if (data.left == undefined || data.right == undefined) {
            throw new ArgumentError( /*"AddExpression requires left and right children."*/);
        }
        this._left = parser.parse(data.left);
        this._right = parser.parse(data.right);
    }
    toString() {
        return "subtract(" + this._left.toString() + ", " + this._right.toString() + ")";
    }
    //INumberExpression-->
    evaluate() {
        return this._left.evaluate() - this._right.evaluate();
    }
}
class Parser {
    constructor(functionValues) {
        this._functionValues = functionValues;
    }
    setFunctionCallValue(functionName, value) {
        this._functionValues.set(functionName, value);
    }
    getFunctionCallValue(functionName) {
        return this._functionValues.get(functionName);
    }
    parse(data) {
        switch (data.op) {
            case "add":
                return new AddExpression(data, this);
            case "constant":
                return new NumberConstantExpression(data);
            case "divide":
                return new DivideExpression(data, this);
            case "functionCall":
                return new FunctionCallExpression(data, this);
            /*case "int":
              return new IntCastExpression(data);*/
            case "modulo":
                return new ModuloExpression(data, this);
            case "multiply":
                return new MultiplyExpression(data, this);
            case "negate":
                return new NegateExpression(data, this);
            case "subtract":
                return new SubtractExpression(data, this);
        }
        throw new ArgumentError("Unknown expression type: " + data.op);
    }
}
class InterceptRoot extends World {
    constructor(testCase) {
        super(testCase);
        this._intercepTestCase = testCase;
    }
    setHookDepth(depth) {
        this._intercepTestCase.setHookDepth(depth);
    }
    getBoatX() {
        return this._intercepTestCase.getBoatX();
    }
}
export class InterceptTestCase extends TestCase {
    constructor(parameterData) {
        super(parameterData);
        this._hookDepth = 0;
        this._fishDepth = 0;
        this._getBoatXFunctionName = "getBoatX";
        this._functionValues = new Map();
        this._gridSpaceWidth = 10;
        this._gridSpaceHeight = 10;
        this._gridWidth = 10;
        this._gridHeight = 10;
        this._millisecondsPerGridSpace = 500;
        //values
        for (let valueKey in parameterData.values) {
            this._functionValues.set(valueKey, parameterData.values[valueKey]);
        }
        //Store where the boat is supposed to be.
        this._boatX = this._functionValues.get(this._getBoatXFunctionName);
        //Expression
        this._parser = new Parser(this._functionValues);
        console.log(parameterData);
        this._expression = this._parser.parse(parameterData.expression);
        //Fish Depth
        this._fishDepth = this.calculateFishY(this._boatX);
        //View
        this._sceneGroup = new SceneGroup();
        let fillSceneGraphic = new FillSceneGraphic(this.canvasWidth, this.canvasHeight, "#073642");
        this._sceneGroup.add(fillSceneGraphic);
        let centerSceneGroup = new CenterSceneGroup();
        centerSceneGroup.width = this.canvasWidth;
        centerSceneGroup.height = 250;
        let textSceneNode = new TextSceneNode(this._expression.toString(), "#839496", "8px serif");
        centerSceneGroup.add(textSceneNode);
        this._sceneGroup.add(centerSceneGroup);
        this._axisSceneGroup = new SceneGroup();
        this._axisSceneGroup.x = 5;
        this._axisSceneGroup.y = 19.05;
        this._fishermanSceneNode = new FishermanSceneNode();
        this._fishermanSceneNode.x = this._boatX * this._gridSpaceWidth;
        this._fishermanSceneNode.y = 0;
        this._axisSceneGroup.add(this._fishermanSceneNode);
        this._hookSceneNode = new HookSceneNode();
        this._hookSceneNode.x = this._boatX * this._gridSpaceWidth;
        this._hookSceneNode.y = 0;
        this._axisSceneGroup.add(this._hookSceneNode);
        //Fishing line
        const fishermanOffsetProxy = new OffsetProxy(this._fishermanSceneNode, 0, -13.26);
        const hookOffsetProxy = new OffsetProxy(this._hookSceneNode, 0, -3.5);
        let fishingLineSceneNode = new LineSceneNode(1, "#93A1A1", fishermanOffsetProxy, hookOffsetProxy);
        this._axisSceneGroup.add(fishingLineSceneNode);
        //Axis Scene Group
        this._axisSceneGroup.add(new AxisSceneGroup(1, this._gridWidth, 1, this._gridHeight, this._gridSpaceWidth, this._gridSpaceHeight));
        //Fish Path
        const fishStartDepth = this.calculateFishY(0);
        const fishEndDepth = this.calculateFishY(9);
        const pathLineSceneNode = new LineSceneNode(0.5, "#295059", { x: 0 * this._gridSpaceWidth, y: fishStartDepth * this._gridSpaceHeight }, { x: 9 * this._gridSpaceWidth, y: fishEndDepth * this._gridSpaceHeight });
        this._axisSceneGroup.add(pathLineSceneNode);
        //Fish
        this._fishSceneNode = new FishSceneNode();
        this._fishSceneNode.x = 0;
        this._fishSceneNode.y = this.calculateFishY(0) * this._gridSpaceHeight;
        this._axisSceneGroup.add(this._fishSceneNode);
        this._sceneGroup.add(this._axisSceneGroup);
    }
    getBoatX() {
        this.log("getBoatX() -> " + this._boatX);
        return this._boatX;
    }
    _gridXToSceneX(gridX) {
        return gridX * this._gridSpaceWidth;
    }
    _gridYToSceneY(gridY) {
        return gridY * this._gridSpaceHeight;
    }
    setHookDepth(depth) {
        depth = Math.max(depth, 0);
        depth = Math.min(depth, this._gridHeight - 1);
        this.log("Set Hook Depth to " + depth);
        this._actionQueue.add(new MoveToAction(this._hookSceneNode, this._gridXToSceneX(this._boatX), this._gridYToSceneY(depth), this._millisecondsPerGridSpace * Math.abs(depth - this._hookDepth)));
        this._hookDepth = depth;
    }
    queueEvaluate() {
        //Send the fish!
        let endX = this.isSuccess ? this._boatX : this._gridWidth;
        this._actionQueue.add(new MoveGraphAction(this._fishSceneNode, this._gridXToSceneX(0), this._gridXToSceneX(endX), (x) => this._gridYToSceneY(this.calculateFishY(x / this._gridSpaceWidth)), 0.1 * this._gridSpaceWidth, this._millisecondsPerGridSpace / this._gridSpaceWidth));
        super.queueEvaluate();
    }
    createSceneNode() {
        return this._sceneGroup;
    }
    get canvasWidth() {
        return 100;
    }
    get canvasHeight() {
        return 125;
    }
    get isSuccess() {
        return this._hookDepth == this._fishDepth;
    }
    //This is the "world" argument that users code against.
    createRoot() {
        return new InterceptRoot(this);
    }
    calculateFishY(fishX) {
        this._parser.setFunctionCallValue(this._getBoatXFunctionName, fishX);
        let fishY = this._expression.evaluate();
        return fishY;
    }
    createElement(document) {
        let template = document.createElement("template");
        let html = `
    <div class="intercept-container">
      <div>
        <div class="intercept-center">
          <input type="number" class="depth_value intercept_value w-full bg-darkBack text-darkFore outline-none" min="0" max="9">
        </div>
        <div class="intercept-center">
          <button class="depth_submit w-full btn-darkBackHigh">Set Hook Depth</button>
        </div>
      </div>
    </div>`;
        html = html.trim(); // Never return a text node of whitespace as the result
        template.innerHTML = html;
        let inputElement = template.content.firstElementChild.getElementsByClassName("depth_value")[0];
        let buttonElement = template.content.firstElementChild.getElementsByClassName("depth_submit")[0];
        buttonElement.addEventListener("click", () => {
            let depthText = inputElement.value;
            let depth = Number(depthText) || 0; //TODO: We should have some error handling for bad numbers?
            this.setHookDepth(depth);
            this.queueEvaluate();
        });
        return template.content.firstElementChild;
    }
    get styleSheet() {
        return `.intercept-container {
      width: 100%;
      height: 100%;
      display: flex;
      direction: column;
      align-items: center;
      justify-content: center;
    }
    .intercept-center {
      text-align: center;
    }
    .intercept_value {
      border: 2px solid var(--color-base02);
    }`;
    }
}
class MoveGraphAction extends Action {
    constructor(object, startX, endX, getY, deltaX, millisecondsPerUnit) {
        super();
        this._tween = null;
        if (startX > endX) {
            throw new Error("Parameter startX must be <= endX");
        }
        this._object = object;
        this._currentX = startX;
        this._currentY = getY(startX);
        this._endX = endX;
        this._getY = getY;
        this._deltaX = deltaX;
        this._millisecondsPerUnit = millisecondsPerUnit;
    }
    start() {
        this.deltaX();
    }
    deltaX() {
        if (this._currentX >= this._endX) {
            TweenLite.set(this._object, { x: this._endX, y: this._getY(this._endX) });
            this._completeEvent.raise();
            return;
        }
        let nextX = Math.min(this._currentX + this._deltaX, this._endX);
        let nextY = this._getY(nextX);
        //console.log("currentX:" + this._currentX + " currentY:" + this._currentY + " nextX:" + nextX + " nextY: " + nextY)
        this._tween = TweenLite.to(this._object, (this._millisecondsPerUnit * (nextX - this._currentX)) / 1000, //TODO: This should be the actual distance traveled not just X
        { x: this._currentX, y: this._currentY, onComplete: () => {
                this._currentX = nextX;
                this._currentY = nextY;
                this.deltaX();
            }
        });
    }
    stop() {
        if (this._tween !== null) {
            this._tween.kill();
            this._tween = null;
            this._completeEvent.raise();
        }
    }
}
class HookSceneNode extends SceneGraphic {
    constructor() {
        super();
        this._width = 5.332;
        this._height = 7.256;
    }
    onRender(ctx) {
        // #layer1
        // #path1684
        ctx.beginPath();
        ctx.fillStyle = 'rgb(189, 188, 188)';
        ctx.lineWidth = 0.500079;
        ctx.moveTo(-1.849952, 1.770973);
        ctx.bezierCurveTo(-1.460286, 1.788193, -1.081308, 1.640940, -0.805505, 1.365150);
        ctx.bezierCurveTo(-0.529701, 1.089359, -0.382442, 0.710401, -0.399664, 0.320756);
        ctx.lineTo(-0.399664, -2.179558);
        ctx.bezierCurveTo(-0.396270, -2.298421, -0.452608, -2.411091, -0.549740, -2.479694);
        ctx.bezierCurveTo(-0.991898, -2.751214, -1.212874, -3.273507, -1.099841, -3.779898);
        ctx.bezierCurveTo(-0.959457, -4.274020, -0.513219, -4.618819, 0.000362, -4.630000);
        ctx.bezierCurveTo(0.498418, -4.619805, 0.937434, -4.300533, 1.100584, -3.829872);
        ctx.bezierCurveTo(1.254258, -3.306614, 1.026076, -2.746580, 0.550464, -2.479693);
        ctx.bezierCurveTo(0.400388, -2.379901, 0.400388, -2.279729, 0.400388, -2.129661);
        ctx.lineTo(0.400388, 0.120603);
        ctx.bezierCurveTo(0.408497, 0.272364, 0.391575, 0.424426, 0.350300, 0.570693);
        ctx.bezierCurveTo(0.232520, 1.660834, -0.655452, 2.506468, -1.750097, 2.570944);
        ctx.bezierCurveTo(-2.889959, 2.699535, -3.927783, 1.904647, -4.100538, 0.770696);
        ctx.bezierCurveTo(-4.192720, -0.009302, -4.209493, -0.796369, -4.150626, -1.579585);
        ctx.bezierCurveTo(-4.132116, -1.784361, -3.955976, -1.938466, -3.750545, -1.929617);
        ctx.bezierCurveTo(-3.644026, -1.930971, -3.541475, -1.889254, -3.466152, -1.813929);
        ctx.bezierCurveTo(-3.390829, -1.738603, -3.349119, -1.636054, -3.350482, -1.529541);
        ctx.lineTo(-3.350482, -1.329576);
        ctx.bezierCurveTo(-3.308783, -1.193240, -3.258661, -1.059623, -3.200406, -0.929496);
        ctx.bezierCurveTo(-3.000393, -0.679635, -2.700318, -0.429471, -2.450273, -0.179420);
        ctx.bezierCurveTo(-2.299698, -0.007728, -2.299698, 0.248967, -2.450273, 0.420659);
        ctx.bezierCurveTo(-2.616756, 0.569355, -2.861632, 0.589715, -3.050387, 0.470555);
        ctx.bezierCurveTo(-3.200463, 0.370384, -3.250400, 0.270591, -3.400438, 0.170420);
        ctx.bezierCurveTo(-3.364695, 1.019948, -2.698167, 1.707958, -1.850159, 1.770666);
        ctx.moveTo(0.000400, -3.779822);
        ctx.bezierCurveTo(-0.080027, -3.782643, -0.158010, -3.751924, -0.214904, -3.695011);
        ctx.bezierCurveTo(-0.271798, -3.638099, -0.302489, -3.560108, -0.299638, -3.479687);
        ctx.bezierCurveTo(-0.302489, -3.399266, -0.271798, -3.321275, -0.214904, -3.264362);
        ctx.bezierCurveTo(-0.158010, -3.207450, -0.080027, -3.176731, 0.000400, -3.179551);
        ctx.bezierCurveTo(0.200450, -3.179551, 0.300438, -3.329619, 0.300438, -3.529584);
        ctx.bezierCurveTo(0.284738, -3.680502, 0.151694, -3.791465, 0.000400, -3.779822);
        ctx.fill();
        // #path1545-3
        ctx.beginPath();
        ctx.fillStyle = 'rgb(220, 50, 47)';
        ctx.lineWidth = 0.453617;
        ctx.moveTo(-0.000244, -0.362114);
        ctx.bezierCurveTo(0.195055, -0.362114, 0.353376, -0.203801, 0.353376, -0.008513);
        ctx.bezierCurveTo(0.353376, 0.186776, 0.195055, 0.345089, -0.000244, 0.345089);
        ctx.bezierCurveTo(-0.195543, 0.345089, -0.353864, 0.186776, -0.353864, -0.008513);
        ctx.bezierCurveTo(-0.353864, -0.203801, -0.195543, -0.362114, -0.000244, -0.362114);
        ctx.fill();
        // #path1686-6
        ctx.beginPath();
        ctx.fillStyle = 'rgb(168, 168, 167)';
        ctx.lineWidth = 0.500079;
        ctx.moveTo(-2.850129, 1.270909);
        ctx.bezierCurveTo(-2.616137, 1.588232, -2.244219, 1.774182, -1.849951, 1.770972);
        ctx.bezierCurveTo(-1.320742, 1.793237, -0.829102, 1.498264, -0.599715, 1.020859);
        ctx.lineTo(-0.149620, 1.820982);
        ctx.bezierCurveTo(-0.540939, 2.273293, -1.089981, 2.559416, -1.684906, 2.621067);
        ctx.bezierCurveTo(-2.199835, 2.657219, -2.711627, 2.516048, -3.135197, 2.221025);
        ctx.fill();
        // #path1688-8
        ctx.beginPath();
        ctx.strokeStyle = 'rgb(255, 238, 231)';
        ctx.lineWidth = 0.125020;
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';
        ctx.moveTo(-3.600280, -1.529462);
        ctx.bezierCurveTo(-3.516752, -0.888703, -3.149483, -0.319475, -2.600085, 0.020733);
        ctx.stroke();
        // #path1690-2
        ctx.beginPath();
        ctx.strokeStyle = 'rgb(255, 238, 231)';
        ctx.lineWidth = 0.125020;
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';
        ctx.moveTo(0.050412, -4.379914);
        ctx.bezierCurveTo(0.050412, -4.379914, -0.899771, -4.479704, -0.899771, -3.379734);
        ctx.stroke();
        // #line1692-2
        ctx.beginPath();
        ctx.strokeStyle = 'rgb(255, 238, 231)';
        ctx.lineWidth = 0.125020;
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';
        ctx.moveTo(-0.849752, -3.029717);
        ctx.lineTo(-0.599701, -2.779678);
        ctx.stroke();
    }
}
class FishSceneNode extends SceneGraphic {
    constructor() {
        super();
        this._width = 26.333;
        this._height = 13.329;
    }
    onRender(ctx) {
        // #layer1
        // #g1597
        ctx.save();
        ctx.transform(3.780050, 0.000000, 0.000000, 3.780050, -1.172580, -11.804800);
        // #g1515
        ctx.save();
        ctx.transform(1.000000, 0.000000, 0.000000, 1.000000, 3.335290, -7.467270);
        // #path1077
        ctx.beginPath();
        ctx.fillStyle = 'rgb(88, 110, 117)';
        ctx.lineWidth = 0.132291;
        ctx.moveTo(-7.846428, 10.160523);
        ctx.bezierCurveTo(-7.965488, 10.015003, -8.256533, 9.856253, -8.600487, 9.750423);
        ctx.bezierCurveTo(-9.103197, 9.604903, -9.552988, 9.631363, -9.609873, 9.816623);
        ctx.bezierCurveTo(-9.649553, 9.975372, -9.371749, 10.200262, -8.948416, 10.345783);
        ctx.bezierCurveTo(-9.279145, 10.491304, -9.504041, 10.676512, -9.464353, 10.822031);
        ctx.bezierCurveTo(-9.411433, 10.994011, -8.961645, 11.020461, -8.458937, 10.874931);
        ctx.bezierCurveTo(-7.956228, 10.729411, -7.585814, 10.464834, -7.638729, 10.292863);
        ctx.bezierCurveTo(-7.648029, 10.226763, -7.727359, 10.187022, -7.846428, 10.160563);
        ctx.fill();
        // #path1079
        ctx.beginPath();
        ctx.fillStyle = 'rgb(88, 110, 117)';
        ctx.lineWidth = 0.132291;
        ctx.moveTo(-4.486223, 9.155113);
        ctx.bezierCurveTo(-4.486223, 9.393233, -4.843412, 9.591673, -5.279972, 9.591673);
        ctx.bezierCurveTo(-5.716536, 9.591673, -6.073721, 9.393233, -6.073721, 9.155113);
        ctx.bezierCurveTo(-6.073721, 8.916983, -5.544556, 8.520113, -5.111962, 8.520113);
        ctx.bezierCurveTo(-4.944500, 8.520452, -4.784131, 8.587762, -4.666590, 8.707042);
        ctx.bezierCurveTo(-4.549049, 8.826323, -4.484103, 8.987663, -4.486223, 9.155113);
        ctx.fill();
        // #path1081
        ctx.beginPath();
        ctx.fillStyle = 'rgb(255, 238, 231)';
        ctx.lineWidth = 0.132291;
        ctx.moveTo(-3.189770, 10.583853);
        ctx.lineTo(-2.713520, 10.213442);
        ctx.bezierCurveTo(-2.991330, 9.644593, -3.957059, 9.234483, -5.134452, 9.234483);
        ctx.bezierCurveTo(-6.153096, 9.234483, -7.211429, 9.565213, -7.767053, 10.015003);
        ctx.bezierCurveTo(-7.844347, 10.108736, -7.902749, 10.216556, -7.939033, 10.332503);
        ctx.bezierCurveTo(-8.044863, 10.702912, -6.364765, 11.628961, -5.041847, 11.628961);
        ctx.bezierCurveTo(-4.076123, 11.628961, -3.242685, 11.324691, -2.872270, 10.874891);
        ctx.fill();
        // #path1083
        ctx.beginPath();
        ctx.fillStyle = 'rgb(255, 238, 231)';
        ctx.lineWidth = 0.132291;
        ctx.moveTo(-3.127590, 10.636773);
        ctx.bezierCurveTo(-3.564154, 10.954271, -4.252068, 11.152711, -5.032587, 11.152711);
        ctx.bezierCurveTo(-6.117381, 11.152711, -7.427064, 10.544164, -7.823938, 10.107613);
        ctx.bezierCurveTo(-7.875104, 10.174016, -7.911217, 10.250753, -7.929773, 10.332503);
        ctx.bezierCurveTo(-8.035603, 10.702912, -6.355505, 11.628961, -5.032587, 11.628961);
        ctx.bezierCurveTo(-4.066858, 11.628961, -3.233425, 11.324691, -2.863010, 10.874891);
        ctx.fill();
        // #path1085
        ctx.beginPath();
        ctx.fillStyle = 'rgb(88, 110, 117)';
        ctx.lineWidth = 0.132291;
        ctx.moveTo(-5.981116, 11.271771);
        ctx.bezierCurveTo(-6.166326, 11.483441, -6.139866, 11.906771, -6.007566, 12.012601);
        ctx.bezierCurveTo(-5.875276, 12.118441, -5.584231, 11.959701, -5.399027, 11.748021);
        ctx.bezierCurveTo(-5.241527, 11.558750, -5.247174, 11.282468, -5.412277, 11.099791);
        ctx.bezierCurveTo(-5.544566, 10.980731, -5.795921, 11.060091, -5.981126, 11.271771);
        ctx.fill();
        // #path1087
        ctx.beginPath();
        ctx.fillStyle = 'rgb(88, 110, 117)';
        ctx.lineWidth = 0.132291;
        ctx.moveTo(-2.647375, 10.173752);
        ctx.bezierCurveTo(-2.792895, 9.525523, -3.798309, 9.022823, -5.028617, 9.022823);
        ctx.bezierCurveTo(-6.153096, 9.022823, -7.304034, 9.446153, -7.753823, 10.015003);
        ctx.bezierCurveTo(-7.198199, 9.565213, -6.139866, 9.234483, -5.121222, 9.234483);
        ctx.bezierCurveTo(-4.787658, 9.234125, -4.455021, 9.269609, -4.129038, 9.340323);
        ctx.bezierCurveTo(-4.496125, 10.039710, -4.379261, 10.894945, -3.837999, 11.470211);
        ctx.bezierCurveTo(-3.458785, 11.374140, -3.114686, 11.172267, -2.845810, 10.888121);
        ctx.lineTo(-3.176540, 10.583853);
        ctx.lineTo(-2.700290, 10.213442);
        ctx.lineTo(-2.700290, 10.213442);
        ctx.fill();
        // #ellipse1089
        ctx.beginPath();
        ctx.fillStyle = 'rgb(255, 238, 231)';
        ctx.lineWidth = 0.132291;
        ctx.moveTo(-3.494036, 9.618136);
        ctx.bezierCurveTo(-3.289461, 9.618136, -3.123620, 9.772132, -3.123620, 9.962094);
        ctx.bezierCurveTo(-3.123620, 10.152057, -3.289461, 10.306052, -3.494036, 10.306052);
        ctx.bezierCurveTo(-3.698611, 10.306052, -3.864452, 10.152057, -3.864452, 9.962094);
        ctx.bezierCurveTo(-3.864452, 9.772132, -3.698611, 9.618136, -3.494036, 9.618136);
        ctx.fill();
        // #circle1091
        ctx.beginPath();
        ctx.fillStyle = 'rgb(27, 31, 58)';
        ctx.lineWidth = 0.132291;
        ctx.arc(-3.414660, 9.962094, 0.145521, 0.000000, 6.28318531, true);
        ctx.fill();
        // #path1093
        ctx.beginPath();
        ctx.fillStyle = 'rgb(88, 110, 117)';
        ctx.lineWidth = 0.132291;
        ctx.moveTo(-4.420078, 10.438344);
        ctx.bezierCurveTo(-4.420078, 10.583853, -4.644973, 10.702912, -4.909557, 10.702912);
        ctx.bezierCurveTo(-5.174142, 10.702912, -5.571016, 10.478024, -5.571016, 10.332503);
        ctx.bezierCurveTo(-5.571016, 10.186982, -5.187367, 10.173752, -4.909557, 10.173752);
        ctx.bezierCurveTo(-4.631743, 10.173752, -4.420078, 10.292823, -4.420078, 10.438344);
        ctx.fill();
        ctx.restore();
        // #path1545
        ctx.beginPath();
        ctx.fillStyle = 'rgb(38, 139, 210)';
        ctx.lineWidth = 0.120000;
        ctx.arc(0.310767, 3.119901, 0.093544, 0.000000, 6.28318531, true);
        ctx.fill();
        ctx.restore();
    }
}
// prettier-ignore
class FishermanSceneNode extends SceneGraphic {
    constructor() {
        super();
        this._width = 33.468;
        this._height = 19.05;
    }
    onRender(ctx) {
        // #layer1
        // #g2920
        ctx.save();
        ctx.transform(0.500003, 0.000000, 0.000000, 0.500003, -0.061621, 5.010810);
        // #path911
        ctx.beginPath();
        ctx.fillStyle = 'rgb(223, 134, 121)';
        ctx.lineWidth = 0.500066;
        ctx.moveTo(35.198863, -21.800312);
        ctx.lineTo(37.849243, -21.800312);
        ctx.bezierCurveTo(38.953952, -21.800324, 39.849490, -22.695871, 39.849492, -23.800580);
        ctx.lineTo(39.849492, -23.800580);
        ctx.bezierCurveTo(39.849494, -24.905292, 38.953955, -25.800844, 37.849243, -25.800856);
        ctx.lineTo(35.198863, -25.800856);
        ctx.bezierCurveTo(34.668357, -25.800856, 34.159579, -25.590113, 33.784456, -25.214989);
        ctx.bezierCurveTo(33.409332, -24.839864, 33.198590, -24.331086, 33.198591, -23.800580);
        ctx.lineTo(33.198591, -23.800580);
        ctx.bezierCurveTo(33.198593, -22.695862, 34.094145, -21.800312, 35.198863, -21.800312);
        ctx.fill();
        // #path913
        ctx.beginPath();
        ctx.fillStyle = 'rgb(223, 210, 205)';
        ctx.lineWidth = 0.500066;
        ctx.moveTo(35.698933, -25.850862);
        ctx.lineTo(35.698933, -21.800312);
        ctx.bezierCurveTo(35.698933, -21.800312, 46.250361, -20.250100, 46.200355, -24.850726);
        ctx.bezierCurveTo(46.200355, -24.850726, 46.700425, -29.301330, 42.949912, -31.701655);
        ctx.bezierCurveTo(42.899902, -31.701655, 39.899502, -26.000881, 35.698933, -25.850862);
        ctx.fill();
        // #path915
        ctx.beginPath();
        ctx.fillStyle = 'rgb(223, 210, 205)';
        ctx.lineWidth = 0.500066;
        ctx.moveTo(48.950728, -32.951826);
        ctx.lineTo(49.450797, -32.901816);
        ctx.bezierCurveTo(49.700810, -32.901816, 49.900857, -32.851806, 50.150892, -32.851806);
        ctx.lineTo(48.700693, -5.998158);
        ctx.lineTo(43.249953, -6.348191);
        ctx.lineTo(43.249953, -31.801652);
        ctx.bezierCurveTo(45.022797, -32.659696, 46.983879, -33.055353, 48.950728, -32.951807);
        ctx.fill();
        // #path917
        ctx.beginPath();
        ctx.fillStyle = 'rgb(97, 109, 62)';
        ctx.lineWidth = 0.500066;
        ctx.moveTo(39.449442, -16.049532);
        ctx.bezierCurveTo(39.449442, -16.049532, 40.899634, -31.801671, 43.299960, -31.801671);
        ctx.lineTo(43.299960, -6.348210);
        ctx.lineTo(35.598920, -6.698280);
        ctx.lineTo(33.998702, -8.948593);
        ctx.bezierCurveTo(37.201404, -9.826949, 39.428769, -12.728650, 39.449442, -16.049551);
        ctx.fill();
        // #path919
        ctx.beginPath();
        ctx.fillStyle = 'rgb(124, 140, 87)';
        ctx.lineWidth = 0.500066;
        ctx.moveTo(60.352268, -12.699073);
        ctx.lineTo(59.952226, -5.248068);
        ctx.bezierCurveTo(59.489915, -5.342694, 59.022340, -5.409482, 58.552025, -5.448071);
        ctx.lineTo(48.750703, -5.998140);
        ctx.lineTo(50.200898, -32.851794);
        ctx.bezierCurveTo(56.401731, -32.101690, 60.952351, -23.250489, 60.352268, -12.699054);
        ctx.fill();
        // #path921
        ctx.beginPath();
        ctx.fillStyle = 'rgb(131, 148, 150)';
        ctx.strokeStyle = 'rgb(131, 148, 150)';
        ctx.lineWidth = 0.453606;
        ctx.miterLimit = 4;
        ctx.moveTo(46.450390, -17.349709);
        ctx.bezierCurveTo(43.120109, -20.366984, 39.580493, -23.027331, 35.871408, -25.300786);
        ctx.bezierCurveTo(34.924647, -25.850862, 34.019054, -26.450944, 33.072300, -26.951010);
        ctx.lineTo(30.232011, -28.501222);
        ctx.lineTo(27.350543, -29.901412);
        ctx.bezierCurveTo(26.856580, -30.151462, 26.362622, -30.351472, 25.909822, -30.551500);
        ctx.lineTo(24.427939, -31.151579);
        ctx.lineTo(22.946058, -31.751661);
        ctx.lineTo(21.464178, -32.301737);
        ctx.bezierCurveTo(20.476256, -32.651770, 19.488337, -33.051838, 18.500415, -33.351879);
        ctx.bezierCurveTo(16.483411, -33.901956, 14.466403, -34.552044, 12.449396, -34.952098);
        ctx.lineTo(10.926351, -35.302130);
        ctx.bezierCurveTo(10.432390, -35.402150, 9.897263, -35.552180, 9.403302, -35.602190);
        ctx.lineTo(6.316060, -36.052250);
        ctx.bezierCurveTo(5.286972, -36.252290, 4.257888, -36.252290, 3.228800, -36.352272);
        ctx.lineTo(0.141551, -36.552312);
        ctx.lineTo(3.228800, -36.302262);
        ctx.bezierCurveTo(4.257888, -36.202242, 5.286972, -36.152270, 6.316060, -35.952230);
        ctx.lineTo(9.403302, -35.452160);
        ctx.bezierCurveTo(9.897263, -35.402150, 10.432390, -35.252120, 10.926351, -35.152138);
        ctx.lineTo(12.449396, -34.802105);
        ctx.bezierCurveTo(14.507569, -34.402052, 16.483411, -33.701957, 18.500415, -33.101875);
        ctx.bezierCurveTo(19.488337, -32.801853, 20.476256, -32.401780, 21.464178, -32.051733);
        ctx.lineTo(22.946058, -31.501660);
        ctx.lineTo(24.386776, -30.851568);
        ctx.lineTo(25.827493, -30.201483);
        ctx.bezierCurveTo(26.316629, -30.015071, 26.797511, -29.798086, 27.268217, -29.551395);
        ctx.lineTo(30.108521, -28.101195);
        ctx.lineTo(32.907645, -26.500981);
        ctx.bezierCurveTo(33.854399, -25.950905, 34.759996, -25.350823, 35.665589, -24.800750);
        ctx.bezierCurveTo(39.314078, -22.490050, 42.797593, -19.813747, 46.079919, -16.799663);
        ctx.fill();
        ctx.stroke();
        // #path923
        ctx.beginPath();
        ctx.fillStyle = 'rgb(252, 170, 151)';
        ctx.lineWidth = 0.500066;
        ctx.moveTo(41.499717, -17.999797);
        ctx.lineTo(45.050200, -17.999797);
        ctx.bezierCurveTo(45.647833, -17.997124, 46.221761, -18.233350, 46.644356, -18.655944);
        ctx.bezierCurveTo(47.066950, -19.078539, 47.303176, -19.652467, 47.300503, -20.250100);
        ctx.lineTo(47.300503, -20.250100);
        ctx.bezierCurveTo(47.303177, -20.847734, 47.066952, -21.421663, 46.644357, -21.844258);
        ctx.bezierCurveTo(46.221762, -22.266854, 45.647834, -22.503080, 45.050200, -22.500407);
        ctx.lineTo(41.499717, -22.500407);
        ctx.bezierCurveTo(40.902084, -22.503080, 40.328156, -22.266852, 39.905562, -21.844257);
        ctx.bezierCurveTo(39.482968, -21.421662, 39.246743, -20.847733, 39.249417, -20.250100);
        ctx.lineTo(39.249417, -20.250100);
        ctx.bezierCurveTo(39.246744, -19.652468, 39.482969, -19.078540, 39.905563, -18.655946);
        ctx.bezierCurveTo(40.328157, -18.233351, 40.902085, -17.997124, 41.499717, -17.999797);
        ctx.fill();
        // #path925
        ctx.beginPath();
        ctx.fillStyle = 'rgb(252, 170, 151)';
        ctx.lineWidth = 0.500066;
        ctx.moveTo(45.850307, -29.751389);
        ctx.lineTo(47.650551, -29.751389);
        ctx.bezierCurveTo(48.711561, -29.751389, 49.729115, -30.172874, 50.479362, -30.923121);
        ctx.bezierCurveTo(51.229610, -31.673369, 51.651094, -32.690923, 51.651094, -33.751933);
        ctx.lineTo(51.651094, -36.502307);
        ctx.bezierCurveTo(51.651085, -38.711740, 49.859984, -40.502834, 47.650551, -40.502834);
        ctx.lineTo(45.850307, -40.502834);
        ctx.bezierCurveTo(43.640874, -40.502834, 41.849773, -38.711740, 41.849764, -36.502307);
        ctx.lineTo(41.849764, -33.751933);
        ctx.bezierCurveTo(41.836194, -32.686821, 42.253319, -31.661363, 43.006528, -30.908154);
        ctx.bezierCurveTo(43.759737, -30.154945, 44.785195, -29.737819, 45.850307, -29.751389);
        ctx.fill();
        // #path927
        ctx.beginPath();
        ctx.fillStyle = 'rgb(93, 53, 35)';
        ctx.lineWidth = 0.500066;
        ctx.moveTo(45.600273, -30.851538);
        ctx.lineTo(45.750303, -30.851538);
        ctx.bezierCurveTo(46.760866, -30.851533, 47.729821, -31.254003, 48.442987, -31.969986);
        ctx.bezierCurveTo(49.156153, -32.685970, 49.554800, -33.656504, 49.550810, -34.667059);
        ctx.lineTo(49.550810, -37.252410);
        ctx.bezierCurveTo(49.545116, -37.697190, 49.460451, -38.137421, 49.300760, -38.552584);
        ctx.bezierCurveTo(49.800830, -37.902494, 51.651079, -37.102390, 51.651079, -36.202266);
        ctx.lineTo(51.651079, -33.451892);
        ctx.bezierCurveTo(51.651079, -32.390882, 51.229595, -31.373328, 50.479347, -30.623080);
        ctx.bezierCurveTo(49.729099, -29.872832, 48.711545, -29.451348, 47.650535, -29.451348);
        ctx.lineTo(45.850292, -29.451348);
        ctx.bezierCurveTo(44.789282, -29.451348, 43.771728, -29.872833, 43.021481, -30.623080);
        ctx.bezierCurveTo(42.271233, -31.373328, 41.849749, -32.390882, 41.849749, -33.451892);
        ctx.lineTo(41.849749, -34.667059);
        ctx.bezierCurveTo(41.825364, -33.659138, 42.210532, -32.684370, 42.917296, -31.965355);
        ctx.bezierCurveTo(43.624061, -31.246339, 44.592066, -30.844477, 45.600257, -30.851538);
        ctx.fill();
        // #path929
        ctx.beginPath();
        ctx.fillStyle = 'rgb(253, 232, 223)';
        ctx.lineWidth = 0.500066;
        ctx.moveTo(52.301179, -29.551365);
        ctx.lineTo(52.301179, -29.551365);
        ctx.bezierCurveTo(56.551757, -29.551365, 56.501751, -25.100761, 56.501751, -25.100761);
        ctx.bezierCurveTo(56.501751, -15.849503, 42.599869, -17.999797, 42.599869, -17.999797);
        ctx.lineTo(42.599869, -22.500407);
        ctx.bezierCurveTo(45.800301, -22.550417, 48.950728, -29.901412, 52.301179, -29.551365);
        ctx.fill();
        // #path931
        ctx.beginPath();
        ctx.fillStyle = 'rgb(227, 106, 17)';
        ctx.lineWidth = 0.500066;
        ctx.moveTo(7.245005, -13.199135);
        ctx.lineTo(7.245005, -16.199551);
        ctx.lineTo(70.603662, -16.199551);
        ctx.lineTo(70.603662, -13.199135);
        ctx.bezierCurveTo(70.614063, -12.559964, 70.546905, -11.921891, 70.403660, -11.298891);
        ctx.lineTo(7.445027, -11.298891);
        ctx.bezierCurveTo(7.328993, -11.926133, 7.262122, -12.561480, 7.245024, -13.199135);
        ctx.fill();
        // #path933
        ctx.beginPath();
        ctx.fillStyle = 'rgb(186, 85, 23)';
        ctx.lineWidth = 0.500066;
        ctx.moveTo(9.645335, -6.398220);
        ctx.bezierCurveTo(8.500289, -7.819795, 7.726957, -9.503945, 7.395035, -11.298891);
        ctx.lineTo(70.353631, -11.298891);
        ctx.bezierCurveTo(70.021704, -9.503943, 69.248368, -7.819793, 68.103317, -6.398220);
        ctx.fill();
        // #path935
        ctx.beginPath();
        ctx.fillStyle = 'rgb(151, 73, 21)';
        ctx.lineWidth = 0.500066;
        ctx.moveTo(58.051963, -1.662584);
        ctx.lineTo(19.846720, -1.662584);
        ctx.bezierCurveTo(15.920946, -1.640119, 12.193265, -3.384599, 9.695341, -6.413226);
        ctx.lineTo(68.203337, -6.413226);
        ctx.bezierCurveTo(65.705414, -3.384601, 61.977735, -1.640121, 58.051963, -1.662584);
        ctx.fill();
        // #rect937
        ctx.save();
        ctx.beginPath();
        ctx.transform(-1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000);
        ctx.fillStyle = 'rgb(187, 91, 23)';
        ctx.lineWidth = 0.500066;
        ctx.rect(-73.253876, -19.149954, 68.709328, 2.950401);
        ctx.fill();
        ctx.restore();
        // #path941
        ctx.beginPath();
        ctx.fillStyle = 'rgb(93, 53, 35)';
        ctx.lineWidth = 0.500066;
        ctx.moveTo(48.100614, -32.401750);
        ctx.lineTo(42.749887, -32.801803);
        ctx.bezierCurveTo(42.449865, -32.801803, 42.349834, -32.551791, 42.199811, -32.201721);
        ctx.bezierCurveTo(42.057448, -32.428055, 41.971680, -32.685342, 41.949761, -32.951826);
        ctx.bezierCurveTo(41.999771, -33.701927, 42.049781, -34.302009, 42.549844, -34.252003);
        ctx.lineTo(45.250210, -33.851946);
        ctx.lineTo(48.200612, -33.901956);
        ctx.bezierCurveTo(48.700678, -33.851946, 49.050729, -33.251871, 49.000719, -32.501766);
        ctx.bezierCurveTo(48.987683, -32.240423, 48.919511, -31.984794, 48.800679, -31.751665);
        ctx.bezierCurveTo(48.650649, -32.101697, 48.400621, -32.401754, 48.100584, -32.401754);
        ctx.fill();
        // #path943
        ctx.beginPath();
        ctx.fillStyle = 'rgb(221, 54, 21)';
        ctx.lineWidth = 0.500066;
        ctx.moveTo(39.299427, -37.402430);
        ctx.lineTo(39.399447, -37.452440);
        ctx.bezierCurveTo(39.449457, -37.502450, 39.499467, -37.502450, 39.549477, -37.552460);
        ctx.lineTo(42.499875, -39.352691);
        ctx.lineTo(42.999941, -41.202944);
        ctx.bezierCurveTo(43.149971, -41.853033, 44.100074, -42.253086, 45.050204, -42.168073);
        ctx.lineTo(49.750839, -41.602998);
        ctx.bezierCurveTo(50.700972, -41.502978, 51.501079, -40.852893, 51.501079, -40.202805);
        ctx.lineTo(51.551089, -38.302557);
        ctx.lineTo(54.001425, -35.852233);
        ctx.lineTo(54.101405, -35.752213);
        ctx.lineTo(54.201385, -35.652193);
        ctx.lineTo(54.151295, -35.652193);
        ctx.bezierCurveTo(54.151295, -35.602183, 54.201385, -35.552173, 54.151295, -35.552173);
        ctx.bezierCurveTo(54.051315, -34.852076, 50.650818, -34.702058, 46.550262, -35.202140);
        ctx.bezierCurveTo(42.449706, -35.702210, 39.149261, -36.602330, 39.249273, -37.302423);
        ctx.bezierCurveTo(39.299283, -37.302423, 39.349293, -37.352433, 39.299283, -37.402443);
        ctx.fill();
        // #polygon945
        ctx.save();
        ctx.beginPath();
        ctx.transform(-0.500068, 0.000000, 0.000000, 0.500068, 73.254000, -42.168100);
        ctx.fillStyle = 'rgb(182, 42, 19)';
        ctx.moveTo(43.400000, 7.730000);
        ctx.lineTo(43.200000, 7.830000);
        ctx.lineTo(61.700000, 5.730000);
        ctx.lineTo(61.500000, 5.630000);
        ctx.lineTo(60.700000, 2.730000);
        ctx.lineTo(43.400000, 4.730000);
        ctx.fill();
        ctx.restore();
        // #path947
        ctx.beginPath();
        ctx.globalAlpha = 0.5;
        ctx.fillStyle = 'rgb(142, 206, 206)';
        ctx.lineWidth = 0.500066;
        ctx.moveTo(33.948696, -10.798810);
        ctx.bezierCurveTo(47.800573, -10.998850, 46.650418, -7.498364, 61.702463, -10.498788);
        ctx.bezierCurveTo(64.570589, -11.069785, 67.480761, -11.404289, 70.403641, -11.498927);
        ctx.lineTo(70.403641, -11.348860);
        ctx.bezierCurveTo(70.071715, -9.553912, 69.298378, -7.869762, 68.153327, -6.448188);
        ctx.bezierCurveTo(65.676529, -3.392431, 61.935023, -1.641480, 58.001953, -1.697546);
        ctx.lineTo(19.796714, -1.697546);
        ctx.bezierCurveTo(15.870942, -1.675078, 12.143262, -3.419552, 9.645335, -6.448173);
        ctx.bezierCurveTo(8.715365, -7.632993, 8.034937, -8.993853, 7.645067, -10.448721);
        ctx.bezierCurveTo(23.347200, -6.498183, 20.196768, -10.598789, 33.948696, -10.798753);
        ctx.fill();
        ctx.restore();
    }
}
